import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  BaseText,
  Heading,
  ContentDisplay,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  PortfolioStrategy,
  PortfolioRiskProfile
} from '@/modules/wealth/services/portfolio';

interface Props {
  strategy?: PortfolioStrategy;
  riskProfile?: PortfolioRiskProfile;
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutStrategy',
  props: {
    strategy: null,
    riskProfile: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



const router = useRouter();

const riskProfileHref = computed(() => {
  return router.resolve({ name: 'myprofile', query: { goBack: 'true' } }).href;
});

return { __sfc: true,router, riskProfileHref, BaseText, Heading, ContentDisplay, SkeletonLoader, ContentDisplayLoader, NebraskaColors }
}

})